export const CAD_STORE_KEY = 'cad';
export const ENTITLEMENTS = {
	CUSTOM_ATTRIBUTE_CREATE: 'CUSTOM_ATTRIBUTE_CREATE',
	CUSTOM_ATTRIBUTE_DELETE: 'CUSTOM_ATTRIBUTE_DELETE',
	CUSTOM_ATTRIBUTE_UPDATE: 'CUSTOM_ATTRIBUTE_UPDATE',
};
